module.exports = __webpack_public_path__ + "img/1F1E6-1F1EC.05104352.svg";